// todo svb this was copied from BNH, but might need some cleaning up
define('lq/numeric',[
    'jquery'
], function ($) {

    var numericInputConfig = {
        minValue: null,
        maxValue: null,
        valueChanged: $.noop,
        valid: $.noop,
        invalid: $.noop,
        decimalSeperator: '.',
        groupSeperator: ','
    };

    $.fn.numericVal = function (value) {
        if (!arguments.length) {
            if ($(this).val() === null || $(this).val() === undefined || $(this).val() === '')
                return null;
            return new Number($(this).val());
        } else {
            return this.each(function () {
                var $this = $(this);
                $this.val(value.toString());
            });
        }
    };

    $.fn.numericInput = function (config) {
        config = $.extend({}, numericInputConfig, config);

        return this.each(function () {
            var $this = $(this);
            var lastValidValue = $this.val();
            var valueChanged = config.valueChanged;
            var valid = config.valid;
            var invalid = config.invalid;
            var decimalSeperator = config.decimalSeperator;
            var groupSeperator = config.groupSeperator;

            $this
                .on('keydown', function (e) {
				    // backspace, delete, tab, escape, enter, comma and all forms of .
				    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 188, 110, 190, 109, 189]) !== -1 ||
				        // Ctrl+A
						(e.keyCode == 65 && e.ctrlKey === true) ||
				        // Ctrl+C
						(e.keyCode == 67 && e.ctrlKey === true) ||
				        // Ctrl+V
						(e.keyCode == 86 && e.ctrlKey === true) ||
				        // home, end, left, right
						(e.keyCode >= 35 && e.keyCode <= 39)) {
				        return;
				    }

				    // check for numbers
				    if ((e.shiftKey && (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105))
				        e.preventDefault();
				})
                .on('keyup', function () {
                    var rawValue = $this.val()
                        .replace(groupSeperator, "")
                        .replace(decimalSeperator, ".");
				    if (rawValue === '' || rawValue === '-') {
				        lastValidValue = rawValue;
				        valueChanged(null);
				        if (rawValue === '')
				            valid();
				        else
				            invalid();
				        return;
				    }

				    if (!$.isNumeric(rawValue)) {
				        $this.val(lastValidValue);
				        valid();
				        return;
				    }

				    var numericValue = new Number(rawValue);

                    // note you can only check the lower boundary after the text field has lost the focus
				    if (config.minValue != null && numericValue < config.minValue) {
				        lastValidValue = numericValue;
				        valueChanged(null);
				        invalid();
				    } else if (config.maxValue != null && numericValue > config.maxValue) {
				        lastValidValue = config.maxValue;
				        $this.val(config.maxValue);
				        valueChanged(config.maxValue);
				        valid();
				    } else {
				        lastValidValue = numericValue;
				        valueChanged(numericValue);
				        valid();
				    }
				})
                .on('blur', function () {
                    var rawValue = $this.val()
                        .replace(groupSeperator, "")
                        .replace(decimalSeperator, ".");

	                if (rawValue && isNaN(rawValue)) {
	                    $this.val('');
	                    valueChanged(null);
	                    valid();
	                } else if (config.minValue != null && rawValue) {
	                    var numericValue = new Number(rawValue);
	                    if (numericValue < config.minValue) {
	                        lastValidValue = config.minValue;
	                        $this.val(config.minValue);
	                        valueChanged(config.minValue);
	                    }
	                    valid();
	                }
	            });
        });
    };
});
